import { render, staticRenderFns } from "./ModuleOrderImg.vue?vue&type=template&id=60e3b353"
import script from "./ModuleOrderImg.vue?vue&type=script&lang=js"
export * from "./ModuleOrderImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports